/**
 * @file
 * Patria mobile menu.
 */

(function ($, Drupal) {

  'use strict';

  Drupal.behaviors.ms_menu = {
    attach: () => {
      // Marketing section menu mobile toggle
      const marketingMenuToggle = $('.marketing-section-menu--toggle');
      const marketingMenu = $('.marketing-section-menu--bottom>ul');

      marketingMenuToggle.on('click', function () {
        $(this).toggleClass('active');
        marketingMenu.toggleClass('open');
      });

      const menuLinkParentSelector = '.marketing-section-menu--bottom .level-1 > .has-submenu > .open-submenu';
      const subMenuLinkSelector = '.marketing-section-menu--bottom .submenu > .has-submenu > .open-submenu';

      // Different menu click functions for desktop and mobile
      if (window.innerWidth >= 1200) {
        // Open first level sub menus when clicking menu items with sub menu
        document.querySelectorAll(menuLinkParentSelector).forEach(function (el) {
          el.addEventListener('click', function () {
            if (this.parentNode.classList.contains('open')) {
              // Remove open class
              this.parentNode.classList.remove('open');
              document.body.classList.remove('ms-menu-open');
            } else {
              // Remove open class from other sub menus and add it to clicked sub menu
              let openSubMenuParents = Array.from(
                document.querySelectorAll('.marketing-section-menu--bottom ul > .has-submenu.open')
              );

              openSubMenuParents.map((subMenuParent) => {
                subMenuParent.classList.remove('open');
              });

              this.parentNode.classList.add('open');
              document.body.classList.add('ms-menu-open');
            }
          });
        });

        // Open other level sub menus when clicking menu items with sub menu
        // Leaving this so it works on desktop when zooming
        document.querySelectorAll(subMenuLinkSelector).forEach(function (el) {
          el.addEventListener('click', function () {
            if (this.parentNode.classList.contains('open')) {
              // Remove open class
              this.parentNode.classList.remove('open');
            } else {
              // Remove open class from other sub menus and add it to clicked sub menu
              let openedSubMenuParents = Array.from(
                document.querySelectorAll('.marketing-section-menu--bottom .submenu > .has-submenu.open')
              );
              openedSubMenuParents.map((subMenuParent) => {
                subMenuParent.classList.remove('open');
              });

              this.parentNode.classList.add('open');

              updateHeight();
            }
          });
        });
      } else {
        // Open mobile sub menu when clicking open-submenu button
        document.querySelectorAll('.open-submenu').forEach(function (el) {
          el.addEventListener('click', function () {
            let parent = this.parentNode;
            let sibling = this.nextElementSibling;

            if (sibling.classList.contains('submenu')) {
              parent.classList.toggle('open');
            }
          });
        });
      }

      // Listen for click events on body to close opened desktop sub menu when clicked outside
      document.body.addEventListener('click', function (event) {
        const activeSubmenu = document.querySelector('.marketing-section-menu--bottom li.open .submenu');
        const buttonSibling = activeSubmenu?.previousElementSibling;

        if (activeSubmenu &&
          window.innerWidth >= 1280 &&
          event.target !== buttonSibling &&
          !activeSubmenu.contains(event.target)
        ) {
          activeSubmenu.parentNode.classList.remove('open');
          document.body.classList.remove('ms-menu-open');
        }
      });

      // Update height of sub menu level 2 if level 3 sub menu is taller
      function updateHeight() {
        const subMenuLevel2 = document.querySelector('.marketing-section-menu--bottom ul > .has-submenu.open > .submenu');

        if (!subMenuLevel2) {
          return;
        }

        let subMenuHeight = 0;
        const ulPadding = 72;

        subMenuLevel2.querySelectorAll('.open > ul').forEach(elem => {
          subMenuHeight = Math.max(subMenuHeight, elem.offsetHeight);
        });

        console.log(subMenuLevel2.offsetHeight);
        console.log(subMenuHeight);

        if (subMenuLevel2.offsetHeight < subMenuHeight) {
          subMenuLevel2.style.height = subMenuHeight + ulPadding + 'px';
        }

      }
    }
  };

})(jQuery, Drupal);
